import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TemplateListComponent } from '../template-list/template-list.component';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { loadLandingPage, saveLandingpage, viewLoadLandingPage } from '../../action/landingpage.action';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-landingpage-dialog',
  templateUrl: './landingpage-dialog.component.html',
  styleUrl: './landingpage-dialog.component.scss'
})
export class LandingpageDialogComponent implements OnInit{
    landingpageForm:FormGroup;
    iconList = [
      { name: 'Shopping Cart', value: 'fa fa-shopping-cart' },
      { name: 'User', value: 'fa fa-user' },
      { name: 'Home', value: 'fa fa-home' },
      { name: 'Bell', value: 'fa fa-bell' },
      { name: 'Heart', value: 'fa fa-heart' },
      { name: 'Envelope', value: 'fa fa-envelope' },
      { name: 'Cogs', value: 'fa fa-cogs' },
      { name: 'Camera', value: 'fa fa-camera' },
      { name: 'Calendar', value: 'fa fa-calendar' },
      { name: 'Lock', value: 'fa fa-lock' },
      { name: 'Briefcase', value: 'fa fa-briefcase' },
      { name: 'Dollar Sign', value: 'fa fa-dollar-sign' },
      { name: 'Cogs (Settings)', value: 'fa fa-cogs' },
      { name: 'Chart Line', value: 'fa fa-chart-line' }
    ];

    constructor(private dialogRef:MatDialogRef<TemplateListComponent>,private fb:FormBuilder,
      @Inject(MAT_DIALOG_DATA) public dialogdata:any,private store:Store,private snackBar:MatSnackBar){
        this.landingpageForm=this.fb.group({
          template_id:[''],
          id:[],
          template_name:['Template_1'],
          banner_header:[''],
          banner_sub_content:[""],
          cta_button_one:[false],
          cta_button_two:[false],
          cta_button_name_one:[''],
          cta_button_link_one:[''],
          cta_button_name_two:[''],
          cta_button_link_two:[''],
          feature:fb.array([]),
          faq:fb.array([]),
          main_color:[],
          sub_color:[],
          keyword:[],
          seo_keyword:[],
          seo_title:[],
          seo_description:[],
          seo_url_name:[],
          feature_heading:[],
          faq_heading:[],
          status:[0],
          feature_content:[""],
          bottom_cta_button_name:[""],
          bottom_cta_button_link:[""],
          bottom_cta_description:[""],
          togglecontrol:[false],
          togglecontrol_cta_2:[false],
          togglecontrol_cta_3:[false],
          lead_source_name:[""],
          lead_source_name_cta_2:[""],
          lead_source_name_cta_3:[""]

        })

    }
  ngOnInit(): void {
    console.log(this.dialogdata,'dialogdatadialogdata')
    if(this.dialogdata != null || this.dialogdata != undefined ||this.dialogdata==""){
      this.landingpageForm.patchValue(this.dialogdata)

      for(let i=0;i<this.dialogdata.feature.length;i++){
        this.editFeature(this.dialogdata.feature[i]);
      }
      for(let j=0;j<this.dialogdata.faq.length;j++){
        this.editFaq(this.dialogdata.faq[j]);
      }
      this.keyword=this.dialogdata.seo_keyword.split(",")
    }else{
      this.addFeature();
      this.addFaq();
    }

  }
  editFeature(data:any){
    const formArray=this.landingpageForm.get('feature') as FormArray;
    formArray.push(this.fb.group({
      featureid:data.featureid,
      feature_sub_heading:data.feature_sub_heading,
      feature_description:data.feature_description,
      feature_icon:data.feature_icon,
      status:data.status,
      landingpage_id:data.landingpage_id,
    }))
  }
    addFeature(){
      const formArray=this.landingpageForm.get('feature') as FormArray;
      formArray.push(this.fb.group({
        // feature_heading:[''],
        feature_sub_heading:[''],
        featureid:[''],
        feature_description:[''],
        feature_icon:[''],
        status:[0],
        landingpage_id:[],
      }))
    }
    removeFeature(index:any){
      const formArray=this.landingpageForm.get('feature') as FormArray;
        formArray.at(index).patchValue({
        status:1
      })
      if((formArray.at(index).get("feature_sub_heading").value==null || formArray.at(index).get("feature_sub_heading").value=="" ) && (formArray.at(index).get("feature_description").value=="" || formArray.at(index).get("feature_description").value==null) && (formArray.at(index).get("feature_icon").value=="" || formArray.at(index).get("feature_icon").value==null)){
        formArray.removeAt(index);
      }else{
        this.store.dispatch(loadLandingPage({landingpage:this.landingpageForm.value}));
        formArray.removeAt(index);
        // this.snackBar.open('Data Deleted Successfully', 'Close', { duration: 3000 });
      }
      // this.store.dispatch(loadLandingPage({landingpage:this.landingpageForm.value}));
      // formArray.removeAt(index);
    }
    editFaq(data:any){
      const formArray=this.landingpageForm.get('faq') as FormArray;
      formArray.push(this.fb.group({
        quetion:data.quetion,
        faqid:data.faqid,
        answer:data.answer,
        status:data.status,
        landingpage_id:data.landingpage_id
      }))
    }
    addFaq(){
      const formArray=this.landingpageForm.get('faq') as FormArray;
      formArray.push(this.fb.group({
        faqid:[''],
        quetion:[''],
        answer:[''],
        status:[0],
        landingpage_id:[],
      }))
    }
    removefaq(index:any){
      const formArray=this.landingpageForm.get('faq') as FormArray;
      formArray.at(index).patchValue({
        status:1
      })
      if((formArray.at(index).get("quetion").value==null || formArray.at(index).get("quetion").value=="" ) && (formArray.at(index).get("answer").value=="" || formArray.at(index).get("answer").value==null) ){
        formArray.removeAt(index);
      }else{
        this.store.dispatch(loadLandingPage({landingpage:this.landingpageForm.value}));
        // this.snackBar.open('Data Deleted Successfully', 'Close', { duration: 3000 });
        formArray.removeAt(index);
      }


    }
    keyword:any=[]
    concateKeyword(){
      let key=this.landingpageForm.get('keyword')?.value.trim()
      this.keyword.push(
        key
      )
      this.updateSeoKeywords()
      this.landingpageForm.get('keyword')?.setValue('');
    }
    removeKeyword(index:any){
      this.keyword.splice(index,1);
      this.updateSeoKeywords()
    }
    private updateSeoKeywords(){
      this.landingpageForm.patchValue({
        seo_keyword:this.keyword.join(', ')
      })
    }
    save(){
      this.store.dispatch(loadLandingPage({landingpage:this.landingpageForm.value}));
      this.dialogRef.close()
      // this.store.dispatch(viewLoadLandingPage());

    }

    close(){
      this.dialogRef.close()
    }
    toggleAction() {
      this.landingpageForm.get('togglecontrol')?.setValue(!this.landingpageForm.get('togglecontrol')?.value);
    }
    toggleAction1() {
      this.landingpageForm.get('togglecontrol_cta_2')?.setValue(!this.landingpageForm.get('togglecontrol_cta_2')?.value);
    }
    toggleAction2() {
      this.landingpageForm.get('togglecontrol_cta_3')?.setValue(!this.landingpageForm.get('togglecontrol_cta_3')?.value);
    }
}
